import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FieldAttendanceLog = Loadable(lazy(() => import("./FieldAttendanceLog")));
const DailyAttendanceSummary = Loadable(
  lazy(() => import("./DailyAttendanceSummary"))
);

const attendanceRoutes = [
  {
    path: "/Attendance/FieldAttendanceLog",
    element: <FieldAttendanceLog />,
  },
  {
    path: "/Attendance/DailyAttendanceSummary",
    element: <DailyAttendanceSummary />,
  },
];
export default attendanceRoutes;
